import styled from 'styled-components';
import { CaptionRegularM } from '../../../../../styles/globals';
import { IThemeProvider } from '../../../../../styles/theme';

export const LegendCont = styled.div`
  display: flex;
  justify-content: center;
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.mikro} 0 0;
  `}
`;

export const MeterCont = styled.div`
  display: flex;
  position: relative;
  width: 100%;
  justify-content: center;
`;

export const MeterDesc = styled(CaptionRegularM)`
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  ${({ theme }: IThemeProvider) => `
    margin: ${theme.layout.spacing.centy} 0 0;
    color: ${theme.colors.neutral.primary[80]};
  `}
`;
